import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo.png"; // Adjust the path and filename as needed
import "./Footer.css";

const Footer = () => (
  <footer className="footer-new">
    <div className="footer-main">
      <div className="footer-col">
        <img src={logo} alt="Naman Finlease Logo" className="footer-logo" />
        <h3>About Us</h3>
        <p>At Naman Finlease Pvt. Ltd, we understand that each client has unique financial needs and aspirations. Therefore, we offer personalized financial solutions tailored to our clients' requirements.</p>
      </div>
      <div className="footer-col">
        <h3>Quick Links</h3>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About Us</Link></li>
          <li><Link to="/service">Our Services</Link></li>
          <li><Link to="/career">Career</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
        </ul>
      </div>
      <div className="footer-col">
        <h3>Contact Info</h3>
        <p><b>Address</b><br/>S-370, Block S, Panchsheel Park South, Panchsheel Park, New Delhi, Delhi 110017</p>
        <p><b>Email</b><br/>Rajeev@namanfinlease.com<br/>nodalofficer@namanfinlease.com</p>
        <p><b>Phone Number</b><br/>9990831500</p>
      </div>
    </div>
    <div className="footer-bottom">
      &copy; {new Date().getFullYear()} Naman Finlease Pvt. Ltd. All Rights Reserved.
    </div>
  </footer>
);

export default Footer;
